import { useCallback, useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { EnvironmentPermission } from '../types';
import { isInSaaSMode } from '../utils/common';
import * as atoms from '../atoms/atoms';
import useCachedEnvironments from './useCachedEnvironments';

const useEnvPermission = () => {
  const selectedEnvId = useRecoilValue(atoms.selectedEnvironmentId);
  const { data: environmentsData } = useCachedEnvironments();

  const currentEnvironment = useMemo(
    () => environmentsData?.find((env) => env.id === selectedEnvId),
    [environmentsData, selectedEnvId],
  );

  const hasPermission = useCallback(
    (permission: EnvironmentPermission) => {
      if (!isInSaaSMode()) {
        return true;
      }
      if (environmentsData == null) {
        return false;
      }
      if (environmentsData.length === 0) {
        return true;
      }
      return !!currentEnvironment?.permissions?.includes(permission);
    },
    [currentEnvironment, environmentsData],
  );

  return hasPermission;
};

export default useEnvPermission;
